<template>
  <div class="list-page">
    <crumbs title="资质评估" />
    <div class="list-page__querybar">
      <el-row>
        <el-col :span="16">
          <el-date-picker
            v-model="queryCondition.publishDate"
            type="daterange"
            :unlink-panels="true"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <el-select
            v-model="queryCondition.isDeal"
            placeholder="运营是否已处理"
            clearable
            style="width: 100%"
          >
            <el-option label="是" :value="1"> </el-option>
            <el-option label="否" :value="0"> </el-option>
          </el-select>
        </el-col>
        <el-col class="fn-text-right" :span="2">
          <el-button
            @click="handleSearch"
            size="medium"
            type="success"
            icon="el-icon-search"
            round
            >查询</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div class="list-page__toolbar"></div>
    <div
      class="list-page__table"
      v-loading="isLoading"
      element-loading-text="拼命加载中"
    >
      <!-- @selection-change="handleSelectionChange" -->
      <el-table
        :data="queryList"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <!-- <el-table-column type="selection" width="40"> </el-table-column> -->
        <el-table-column
          prop="account"
          label="账号昵称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="registerPhoneNumber"
          label="注册时手机号"
          width="110"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="contact"
          label="联系人"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="phoneNumber"
          label="联系电话"
          width="110"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="companyName"
          label="公司名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="position"
          label="职务"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="认定自评次数"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <a
              href="javascript:;"
              class="clickable-link"
              @click="handleCount(scope.row)"
              >{{ scope.row.evaluateCount }}</a
            >
          </template>
        </el-table-column>
        <el-table-column
          label="企业评价得分自评次数"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <a
              href="javascript:;"
              class="clickable-link"
              @click="handleScoreCount(scope.row)"
              >{{ scope.row.evaluatePointCount }}</a
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="lastUpdateTime"
          label="最后自评时间"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="isDealName"
          label="运营是否已处理"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              :type="scope.row.isDeal ? 'warning' : 'success'"
              @click="handleChangeStatus(scope.row)"
              plain
              >{{ scope.row.isDeal ? "改为未处理" : "置为已处理" }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fn-text-center mt-20">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="true"
          :total="total"
          :page-size="queryCondition.pageSize"
          :current-page.sync="queryCondition.pageIndex"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>

    <evaluate-count
      v-if="evaluateCountDialog"
      :userId="userId"
      @close="evaluateCountDialog = false"
    />
    <evaluate-score-count
      v-if="evaluateScoreCountDialog"
      :userId="userId"
      @close="evaluateScoreCountDialog = false"
    />
  </div>
</template>

<script>
export default {
  name: "qualificationEvaluateList",
  data() {
    return {
      //查询条件
      queryCondition: {
        publishDate: [],
        pageIndex: 1,
        pageSize: 15,
        isDeal: ""
      },
      total: 0,
      //是否处于loading状态
      isLoading: true,
      //查询结果
      queryList: [],
      //表格当前的选项（多选）
      multipleSelection: [],
      userId: "",
      // 次数弹框
      evaluateCountDialog: false,
      evaluateScoreCountDialog: false
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    handleCount(row) {
      this.evaluateCountDialog = true;
      this.userId = row.userId;
    },
    handleScoreCount(row) {
      this.evaluateScoreCountDialog = true;
      this.userId = row.userId;
    },
    //出来参数
    processParams() {
      let { pageIndex, pageSize, publishDate } = this.queryCondition,
        mixin = { isDeal: "" },
        [createBegin = "", createEnd = ""] = publishDate || [];
      Object.keys(mixin).map((item) => {
        mixin[item] =
          this.queryCondition[item] === "" ? -1 : this.queryCondition[item];
      });
      return {
        pageIndex,
        pageSize,
        ...mixin,
        createBegin,
        createEnd
      };
    },
    //获取列表
    loadList() {
      //初始化
      // this.queryList = [];
      this.isLoading = true;
      this.$api(
        "service",
        "getQualificationEvaluate",
        this.processParams()
      ).then((res) => {
        this.isLoading = false;
        this.total = res.count;
        this.queryList = res.dataList;
      });
    },
    //点击后查询
    handleSearch() {
      this.queryCondition.pageIndex = 1;
      this.loadList();
    },
    //表格相关
    //点击选中/取消选中表格选择项
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    handleChangeStatus(row) {
      const { id, isDeal } = row;
      this.$api("service", "changeQualificationEvaluateStatus", {
        id,
        isDeal: !isDeal
      }).then((res) => {
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.loadList();
        }
      });
    },
    //点击切换分页触发
    handleCurrentChange() {
      this.loadList();
    }
  }
};
</script>

<style></style>
